import { LoadablePaint } from '@confluence/loadable';

export const ExternalSharePageLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ExternalShareRouteComponent" */ '../src/ExternalSharePage.tsx'
			)
		).ExternalSharePage,
});
